//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import ecommerceIntegrationsFaqFooterTemplate from '@legacy-components/ecommerce-integrations/ecommerce-integrations-faq-footer.html';

(function() {
  angular.module('curalate').component('ecommerceIntegrationsFaqFooter', {
    bindings: {
      handleFaqLinkClick: '&',
    },
    template: ecommerceIntegrationsFaqFooterTemplate,
    controller: ['SessionVarsService',
      function(SessionVarsService) {
        this.$onInit = () => {
          const isMagentoEnabled = SessionVarsService.isFeatureEnabled('ecommerce_integrations_magento');
          const isShopifyEnabled = SessionVarsService.isFeatureEnabled('ecommerce_integrations_shopify');
          if (isMagentoEnabled) {
            this.ecommerceIntegration = 'magento';
            this.ecommerceSetupLink = 'https://support.bazaarvoice.com/s/article/Setting-up-a-Product-Catalog-via-Magento-2';
          } else if (isShopifyEnabled) {
            this.ecommerceIntegration = 'shopify';
            this.ecommerceSetupLink = 'https://support.bazaarvoice.com/s/article/Setting-up-a-Product-Catalog-via-Shopify';
          } else {
            this.ecommerceSetupLink = 'http://developers.curalate.com/guide/product-catalogs/';
          }
        };
      },
    ],
  });
})();
